import React from 'react';
import { EventDetailsTabView } from '@mark43/cad-api';
import { TabIndented } from '../../../../../panels/entity-panels/tabs/tab-indented';
import { TabSection } from '../../../../../panels/entity-panels/tabs/tab-section';
import { TimestampsSectionContent } from './timestamps-section-content';

export function TimestampsSection(
    props: Partial<EventDetailsTabView & { isScheduled: boolean }>
): React.ReactElement {
    return (
        <TabSection title="Timestamps">
            <TabIndented>
                <TimestampsSectionContent {...props} />
            </TabIndented>
        </TabSection>
    );
}
